/**
 * @file Privacy.js
 * @author Stanley Chen
 * @description Component that displays the terms and conditions/privacy policy
 * for Kiku Japanese Steakhouse website
 */

import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Privacy.css';

const Privacy = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.2 });

    return (
        <section className="privacy-section" id="privacy" ref={ref}>
            <img
                src="/images/mtnbg.jpg"
                alt="Background"
                className="privacy-background"
            />
            <div className="privacy-container">
                <motion.h1
                    className="privacy-title"
                    initial={{ opacity: 0, y: -20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
                    transition={{ duration: 0.6 }}
                >
                    TERMS AND CONDITIONS
                </motion.h1>

                <div className="privacy-card">
                    <div className="privacy-content">
                        <h1>Kiku Japanese Steakhouse and Sushi Bar – Terms & Privacy</h1>
                        <p>
                            Welcome to Kiku Japanese Steakhouse (“Kiku,” “we,” “our,” or “us”).
                            By using our website (the “Site”), you agree to these Terms of
                            Service and our Privacy Policy. If you don’t agree, please do not
                            use the Site. We may update these Terms at any time. Please check this page
                            for the latest version.
                        </p>

                        <h2>Terms of Service</h2>

                        <h3>1. Site Use</h3>
                        <p>
                            Use our Site to view menus, place orders, or contact us.
                            Please use it lawfully. You agree NOT to use the Site for any unlawful purpose or in a manner that
                            could damage, disable, overburden, or impair the Site. Prohibited activities
                            include, but are not limited to, attempting to gain unauthorized
                            access to the Site, using the Site to distribute malware, or engaging in any activity
                            that interferes with the proper functioning of the Site.
                        </p>

                        <h3>2. Intellectual Property</h3>
                        <p>
                            All content belongs to Kiku or our partners. You may use it
                            for personal reference only. No copying, modifying, or redistribution
                            without permission.
                        </p>

                        <h3>3. Disclaimer</h3>
                        <p>
                            Our Site is provided “as is.” We can’t promise it will always work
                            perfectly or be error-free.
                        </p>

                        <h3>4. Limitation of Liability</h3>
                        <p>
                            We’re not liable for any indirect or incidental damages related
                            to your use of the Site.
                        </p>

                        <h3>5. Third Party Vendors/External Links</h3>
                        <p>
                            We may link to other third-party sites, including but not limited to Online Ordering/Delivery Services. We're not responsible for their content
                            or privacy practices.
                        </p>

                        <h3>8. Termination</h3>
                        <p>
                            We may limit or remove access to the Site if you violate these Terms.
                        </p>

                        <h2>Privacy Policy</h2>

                        <h3>1. What We Collect</h3>
                        <p>
                            We may collect your name, email, phone number, order info, and
                            payment details when you engage with our services.
                        </p>

                        <h3>2. How We Use It</h3>
                        <p>
                            We use your info to process orders, improve service, and send updates
                            (if you opted in).
                        </p>

                        <h3>3. Sharing</h3>
                        <p>
                            We don’t sell your data. We may share it with service providers
                            or as required by law. Any personal data shared with third-party platforms
                            for the purpose of ordering or delivery is subject to their privacy policy, not ours.
                        </p>

                        <h2>Contact Us</h2>
                        <p>
                            If you have any questions, email us at:{" "}
                            <a href="kikusteakhouse8868@gmail.com">kikusteakhouse8868@gmail.com</a>
                        </p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Privacy;
